define(['jquery', '../core/cookies'], function($, CookiesHelper){

    var $cookieBox = $('#cookies');

    function CookieInfo(){}

    CookieInfo.prototype.init = function(){
        this.checkCookies();
    };

    CookieInfo.prototype.checkCookies = function () {

        var _this = this;

        if(!$cookieBox.length) return;

        if(CookiesHelper.getCookie('bauwerk.visited')) return;

        _this.showInfo();

        $cookieBox.find('.hide-cookies').click( function () {
            _this.hideInfo();
        });

        $cookieBox.find('.accept-cookies').click( function () {
            _this.acceptCookies();
            _this.hideInfo();
        });

    };

    CookieInfo.prototype.showInfo = function() {
        $cookieBox.fadeIn('slow');
    };

    CookieInfo.prototype.hideInfo = function() {
        $cookieBox.fadeOut('slow');

    };

    CookieInfo.prototype.acceptCookies = function(){
        CookiesHelper.setCookie('bauwerk.visited', 1, 99999);
    };

    return CookieInfo;
});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/cookiesInfo.js